import { EmptyCell } from "./EmptyCell"

export const MoneyLabel = ({ value, currency }) => {
  if (!value && value !== 0) return <EmptyCell />
  const formattedValue = new Intl.NumberFormat("pt-BR", { style: "currency", currency }).format(value)
  return <div>{formattedValue}</div>
}
